import { render, staticRenderFns } from "./CmgRewardsAchievementItem.vue?vue&type=template&id=a048fae2&scoped=true&lang=pug"
import script from "./cmg-rewards-achievement-item.ts?vue&type=script&lang=ts&external"
export * from "./cmg-rewards-achievement-item.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRewardsAchievementItem.vue?vue&type=style&index=0&id=a048fae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a048fae2",
  null
  
)

export default component.exports